import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "../styles/header.css"; // Import the CSS file
import logo from "../assets/icon.png"; // Import the logo image

const Header = ({ language, setLanguage }) => {
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <header className="header">
      <div className="container">
        {/* Brand Name */}
        <div className="brand-name">V-Assistant</div>

        {/* Logo with Link */}
        <div className="logo-container">
          <Link to="/"> {/* Redirect to main page */}
            <img src={logo} alt="V-Assistant Logo" className="logo" />
          </Link>
        </div>

        {/* Language Selector */}
        <div className="language-selector">
          <select value={language} onChange={handleLanguageChange}>
            <option value="en">English</option>
            <option value="pl">Polski</option>
          </select>
        </div>
      </div>
    </header>
  );
};

export default Header;